import type { SortBy, SortByItem } from '@autobid/ui/types/components/CarsList'

export function getSortBy(name: SortByItem['name'], order: SortByItem['order']): SortBy {
  if (name === 'catalogNumber') {
    return [
      {
        name,
        order,
      },
      { name: 'auctionStartDate', order: 'ASCENDING' },
      { name: 'auctionNumber', order: 'ASCENDING' },
    ]
  }

  if (name === 'auctionStartDate') {
    return [
      {
        name,
        order,
      },
      { name: 'catalogNumber', order: 'ASCENDING' },
      { name: 'auctionNumber', order: 'ASCENDING' },
    ]
  }

  return [
    {
      name,
      order,
    },
    { name: 'auctionStartDate', order: 'ASCENDING' },
    { name: 'catalogNumber', order: 'ASCENDING' },
  ]
}

export function getRange(from?: string | number, to?: string | number) {
  if (typeof from !== 'number' && typeof to !== 'number') {
    return undefined
  }

  return {
    valueFrom: typeof from === 'number' ? from : null,
    valueTo: typeof to === 'number' ? to : null,
  }
}
